// extracted by mini-css-extract-plugin
var _1 = "ViewingApplicantsItem-moduleViewingApplicantsItem__jywg4";
var _2 = "ViewingApplicantsItem-modulehover__MhG8u";
export { _1 as "ViewingApplicantsItem", _2 as "hover" }
